/**
 * Table Colors Component Exports
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

export { TableColorsComponent } from './component';
export type {
	TableColorsAttributes,
	TableColorsComponentProps,
	TableColorsValues,
} from './types';
